// extracted by mini-css-extract-plugin
export default {"AboutMePage":"style_AboutMePage__CbacB"};